import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { v3ParsedGroupOrderIdFromRouteParams } from './group-order-app-path';

/**
 * v3 storefront requires `?id=` (or legacy `?groupOrderId=`) on every `/store` URL.
 * Without it, send shoppers to the app 404 page.
 */
export const v3StorefrontOrderIdGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const q = router.parseUrl(state.url).queryParams;
  const parsed = v3ParsedGroupOrderIdFromRouteParams(q);
  if (parsed == null) {
    return router.createUrlTree(['/page-not-found']);
  }
  return true;
};
